import { CardGroup, CardStatus, RelatedCard, RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { RelatedCardUserActions } from '../enums';
import { RelatedCardActions } from './related-card.actions';

export interface RelatedCardState {
    all: RelatedCard[];
    allNormalized: any; // rename to byId in future
    allIds: any[];
    typeEmailIds: any[]; // email type Q
    typeTravelcardIds: any[]; // travelcard type 'U' / 'N' ?
    typePersonalCodeIds: any[]; // type 'C'
    selectedId: number | string;
    selected: RelatedCard; // this should be id (should be removed when possible)
    selectedIds;
    sortField;
    sortDirection;
    favoriteJourneys; // this should not be in here
    selectedFavoriteJourney; // this should not be in here
    loaded: boolean;
    error: any;
    selectedCardUserActions: RelatedCardUserActions[];
    isActionCompleted: boolean;
    editMode: boolean;
    isFormSubmitted: boolean;
    isBlockingFinished: boolean;
    isUnBlockingFinished: boolean;
    allDiscountGroups: CardGroup[];
    selectedDiscountGroup: CardGroup;
    cardStatus: CardStatus;
    seutulippu: {
        isCompleted: boolean;
        loading: boolean;
        error: any;
    };
}
export const RELATED_CARD_INITIAL_STATE: RelatedCardState = {
    all: [],
    allNormalized: {},
    allIds: [],
    typeEmailIds: [],
    typeTravelcardIds: [],
    typePersonalCodeIds: [],
    selectedId: null,
    selected: null,
    selectedIds: [],
    sortField: '',
    sortDirection: '',
    favoriteJourneys: [],
    selectedFavoriteJourney: null,
    loaded: false,
    error: null,
    selectedCardUserActions: [],
    isActionCompleted: false,
    editMode: false,
    isFormSubmitted: false,
    isBlockingFinished: false,
    isUnBlockingFinished: false,
    allDiscountGroups: [],
    selectedDiscountGroup: null,
    cardStatus: null,
    seutulippu: {
        isCompleted: null,
        loading: false,
        error: null
    }
};

export const RELATED_CARD_STATE_KEY = 'related_card';

export function relatedCardReducer(
    lastState: RelatedCardState = RELATED_CARD_INITIAL_STATE,
    action: RidangoReduxAction
): RelatedCardState {
    let normalized = {};
    switch (action.type) {
        case RelatedCardActions.SET_ALL_RELATED_CARDS:
            return tassign(lastState, { all: action.payload });

        case RelatedCardActions.SET_ALL_RELATED_CARDS_NORMALIZED:
            action.payload.map((rc) => {
                normalized = { ...normalized, [rc.id]: rc };
            });
            return tassign(lastState, { allNormalized: normalized });

        case RelatedCardActions.SET_SELECTED_RELATED_CARD:
            return tassign(lastState, {
                selected: action.payload,
                selectedId: action.payload ? action.payload.id : action.payload // need to take care of null set
            });

        case RelatedCardActions.TOGGLE_RELATED_CARD:
            if (lastState.selectedIds.indexOf(action.payload) >= 0) {
                // travel card exists, remove
                return tassign(lastState, {
                    selectedIds: [
                        ...lastState.selectedIds.slice(0, lastState.selectedIds.indexOf(action.payload)),
                        ...lastState.selectedIds.slice(lastState.selectedIds.indexOf(action.payload) + 1)
                    ]
                });
            } else {
                // add travel card
                return tassign(lastState, { selectedIds: [...lastState.selectedIds, action.payload] });
            }

        case RelatedCardActions.TOGGLE_ALL_RELATED_CARDS:
            if (lastState.allIds.length > 0 && lastState.allIds.length !== lastState.selectedIds.length) {
                return tassign(lastState, { selectedIds: lastState.allIds });
            } else {
                return tassign(lastState, { selectedIds: [] });
            }

        case RelatedCardActions.SET_ALL_CARDS_IDS:
            return tassign(lastState, { allIds: action.payload });

        case RelatedCardActions.SORT_RELATED_CARDS: {
            const field = action.payload;
            let direction = 'asc';
            if (
                lastState.sortField &&
                lastState.sortField === action.payload &&
                lastState.sortDirection &&
                lastState.sortDirection === 'asc'
            ) {
                direction = 'desc';
            }

            const cards = lastState.all.sort((a, b) => {
                if (a[field] < b[field]) {
                    return direction === 'asc' ? -1 : 1;
                } else if (a[field] > b[field]) {
                    return direction === 'asc' ? 1 : -1;
                } else {
                    return 0;
                }
            });

            const allIds = [];

            cards.map((c) => {
                normalized = { ...normalized, [c.id]: c };
                allIds.push(c.id);
            });

            return tassign(lastState, {
                all: cards,
                allNormalized: normalized,
                allIds: allIds,
                sortField: field,
                sortDirection: direction
            });
        }

        case RelatedCardActions.RESET_RELATED_CARDS:
            return tassign(lastState, RELATED_CARD_INITIAL_STATE);

        case RelatedCardActions.SET_FAVORITE_JOURNEYS:
            return tassign(lastState, { favoriteJourneys: action.payload });

        case RelatedCardActions.SET_SELECTED_FAVORITE_JOURNEY:
            return tassign(lastState, { selectedFavoriteJourney: action.payload });

        case RelatedCardActions.FETCH_ALL_RELATED_CARDS:
            return tassign(lastState, { loaded: false });

        case RelatedCardActions.FETCH_ALL_RELATED_CARDS_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                // selectedId: null,
                selectedIds: [],
                selected: null,
                loaded: true,
                error: null,
                isBlockingFinished: false,
                isUnBlockingFinished: false
            });

        case RelatedCardActions.FETCH_ALL_RELATED_CARDS_FAILED:
            return tassign(lastState, {
                all: [],
                allIds: [],
                allNormalized: {},
                selectedId: null,
                selectedIds: [],
                selected: null,
                loaded: true,
                isBlockingFinished: false,
                isUnBlockingFinished: false,
                error: action.payload
            });

        case RelatedCardActions.FETCH_CARDS_DISCOUNT_GROUPS_SUCCESS:
            return tassign(lastState, {
                allDiscountGroups: action.payload
            });

        case RelatedCardActions.FETCH_CARDS_DISCOUNT_GROUPS_FAILED:
            return tassign(lastState, {
                error: action.payload
            });

        case RelatedCardActions.SET_CARDS_DISCOUNT_GROUPS:
            return tassign(lastState, {
                allDiscountGroups: action.payload
            });

        case RelatedCardActions.SET_SELECTED_DISCOUNT:
            return tassign(lastState, {
                selectedDiscountGroup: action.payload
            });

        case RelatedCardActions.SET_SELECTED_CARD_USER_ACTIONS:
            return tassign(lastState, {
                selectedCardUserActions: action.payload
            });
        case RelatedCardActions.RESET_RELATED_CARD_STATUS:
            return tassign(lastState, {
                isActionCompleted: false,
                cardStatus: null
            });

        case RelatedCardActions.CLEAR_SELECTED_RELATED_CARD:
            return tassign(lastState, {
                selected: null
            });

        case RelatedCardActions.SET_RELATED_CARD_EDIT_MODE:
            return tassign(lastState, {
                editMode: action.payload
            });
        case RelatedCardActions.SAVE_NEW_RELATED_CARD:
            return tassign(lastState, {
                isActionCompleted: false,
                loaded: false
            });
        case RelatedCardActions.SAVE_NEW_RELATED_CARD_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                isActionCompleted: true,
                error: null,
                loaded: true
            });
        case RelatedCardActions.SAVE_NEW_RELATED_CARD_FAILED:
            return tassign(lastState, {
                error: action.payload,
                isActionCompleted: true,
                loaded: true
            });
        case RelatedCardActions.SAVE_EDITED_RELATED_CARD:
            return tassign(lastState, {
                isActionCompleted: false,
                loaded: false
            });
        case RelatedCardActions.SAVE_EDITED_RELATED_CARD_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                isActionCompleted: true,
                error: null,
                loaded: true
            });
        case RelatedCardActions.SAVE_EDITED_RELATED_CARD_FAILED:
            return tassign(lastState, {
                error: action.payload,
                isActionCompleted: true,
                loaded: true
            });
        case RelatedCardActions.DELETE_RELATED_CARD:
            return tassign(lastState, {
                isActionCompleted: false
            });
        case RelatedCardActions.DELETE_RELATED_CARD_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                isActionCompleted: true,
                error: null
            });
        case RelatedCardActions.DELETE_RELATED_CARD_FAILED:
            return tassign(lastState, {
                error: action.payload,
                isActionCompleted: true
            });
        case RelatedCardActions.BLOCK_RELATED_CARD:
            return tassign(lastState, {
                isBlockingFinished: false,
                error: null
            });
        case RelatedCardActions.BLOCK_RELATED_CARD_SUCCESS:
            return tassign(lastState, {
                isBlockingFinished: true,
                error: null
            });
        case RelatedCardActions.BLOCK_RELATED_CARD_FAILED:
            return tassign(lastState, {
                error: action.payload,
                isBlockingFinished: true
            });
        case RelatedCardActions.BLOCK_AND_REPLACE_RELATED_CARD:
            return tassign(lastState, {
                isBlockingFinished: false
            });
        case RelatedCardActions.UN_BLOCK_RELATED_CARD:
            return tassign(lastState, {
                isUnBlockingFinished: false,
                error: null
            });
        case RelatedCardActions.UN_BLOCK_RELATED_CARD_SUCCESS:
            return tassign(lastState, {
                isUnBlockingFinished: true
            });
        case RelatedCardActions.UN_BLOCK_RELATED_CARD_FAILED:
            return tassign(lastState, {
                isUnBlockingFinished: true,
                error: action.payload
            });
        case RelatedCardActions.FETCH_CARD_STATUS_SUCCESS: {
            let response = action.payload;
            if (response.registered_to_current_customer === undefined) {
                response = {
                    registered: response.registered,
                    registered_to_current_customer: null
                };
                return tassign(lastState, {
                    cardStatus: response
                });
            } else {
                return tassign(lastState, {
                    cardStatus: response
                });
            }
        }
        case RelatedCardActions.FETCH_CARD_STATUS_FAILED:
            return tassign(lastState, {
                error: action.payload
            });
        case RelatedCardActions.SAVE_SEUTULIPPU_CARD:
            return tassign(lastState, {
                seutulippu: {
                    isCompleted: false,
                    loading: true,
                    error: null
                }
            });
        case RelatedCardActions.SAVE_SEUTULIPPU_CARD_SUCCESS:
            return tassign(lastState, {
                seutulippu: {
                    isCompleted: true,
                    loading: false,
                    ...action.payload
                }
            });
        case RelatedCardActions.SAVE_SEUTULIPPU_CARD_FAILED:
            return tassign(lastState, {
                seutulippu: {
                    isCompleted: true,
                    loading: false,
                    error: action.payload
                }
            });
    }

    return lastState;
}

export interface RelatedCardPartialStoreState {
    [RELATED_CARD_STATE_KEY]: RelatedCardState;
}
